import { useState, useEffect } from "react";
import "./App.css";
import { COLORS } from "./utils/COLORS";
import { Routes, Route } from "react-router-dom";
import Privacy from "./pages/privacy";
import AppleIcon from "@mui/icons-material/Apple";

function App() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "unset";
    };
  }, []);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <div
            className="App"
            style={{
              backgroundColor: COLORS.hotYellow,
              height: "100vh",
              padding: "20px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              transition: "all 0.5s ease-in-out",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Decorative background elements */}
            <div className="background-shapes">
              {[...Array(5)].map((_, i) => (
                <div
                  key={i}
                  style={{
                    position: "absolute",
                    background: COLORS.hotPink,
                    borderRadius: "50%",
                    opacity: 0.1,
                    transform: `scale(${isLoaded ? 1 : 0})`,
                    transition: `transform 0.5s ease-in-out ${i * 0.1}s`,
                    ...getRandomPosition(),
                  }}
                />
              ))}
            </div>

            {/* Main content container */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "20px",
                maxWidth: "1200px",
                width: "100%",
                height: "100%", // Add this
                justifyContent: "center", // Add this
                opacity: isLoaded ? 1 : 0,
                transform: `translateY(${isLoaded ? 0 : "20px"})`,
                transition: "all 0.8s ease-in-out",
                position: "relative",
              }}
            >
              <div
                style={{
                  // flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                {/* Logo section */}
                <div
                  style={{
                    backgroundColor: COLORS.hotPink,
                    padding: "30px 60px",
                    borderRadius: "35px",
                    display: "inline-block",
                    boxShadow: "0 20px 40px rgba(255, 20, 147, 0.2)",
                    transform: `scale(${isLoaded ? 1 : 0.9})`,
                    transition: "all 0.3s ease-in-out",
                    cursor: "default",
                  }}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                >
                  <h1
                    style={{
                      color: COLORS.white,
                      fontSize: "clamp(48px, 8vw, 96px)",
                      fontWeight: "bold",
                      margin: 0,
                      fontFamily: "'Helvetica Neue', Arial, sans-serif",
                      letterSpacing: "2px",
                      transform: `scale(${isHovered ? 1.02 : 1})`,
                      transition: "transform 0.3s ease-in-out",
                    }}
                  >
                    PURELY APP
                  </h1>
                </div>

                {/* App Store button */}
                <div
                  style={{
                    transform: `translateY(${isLoaded ? 0 : "20px"})`,
                    opacity: isLoaded ? 1 : 0,
                    transition: "all 0.5s ease-in-out 0.3s",
                  }}
                >
                  <a
                    href="https://apps.apple.com/us/app/purely-cosmetic-scanner/id6740288602"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      backgroundColor: "black",
                      color: "white",
                      padding: "20px 40px",
                      borderRadius: "12px",
                      textDecoration: "none",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "8px",
                      fontSize: "18px",
                      fontWeight: "500",
                      fontFamily: "'Helvetica Neue', Arial, sans-serif",
                      letterSpacing: "0.5px",
                      boxShadow: "0 10px 20px rgba(0, 0, 0, 0.1)",
                      transition: "all 0.3s ease-in-out",
                      position: "relative",
                      overflow: "hidden",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow =
                        "0 15px 30px rgba(0, 0, 0, 0.15)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 10px 20px rgba(0, 0, 0, 0.1)";
                    }}
                  >
                    <AppleIcon /> Install on App Store
                  </a>
                </div>
              </div>

              {/* Privacy Footer */}
              <div
                style={{
                  paddingBottom: "20px",
                  position: "absolute",
                  bottom: 0,
                  opacity: isLoaded ? 1 : 0,
                  transition: "opacity 0.5s ease-in-out 0.5s",
                }}
              >
                <a
                  href="/privacy"
                  style={{
                    color: "rgba(0, 0, 0, 0.6)",
                    textDecoration: "none",
                    fontSize: "14px",
                    fontFamily: "'Helvetica Neue', Arial, sans-serif",
                    transition: "color 0.3s ease-in-out",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = "rgba(0, 0, 0, 0.8)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = "rgba(0, 0, 0, 0.6)";
                  }}
                >
                  Privacy
                </a>
                <p
                  style={{
                    color: "rgba(0, 0, 0, 0.6)",
                    fontSize: "14px",
                    fontFamily: "'Helvetica Neue', Arial, sans-serif",
                    marginTop: "10px",
                  }}
                >
                  <a
                    href="mailto:onepaceapps@gmail.com"
                    style={{
                      color: "rgba(0, 0, 0, 0.6)",
                      textDecoration: "none",
                      transition: "color 0.3s ease-in-out",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = "rgba(0, 0, 0, 0.8)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.color = "rgba(0, 0, 0, 0.6)";
                    }}
                  >
                    onepaceapps@gmail.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        }
      />

      <Route path="/privacy" element={<Privacy />} />
    </Routes>
  );
}

function getRandomPosition() {
  return {
    width: Math.random() * 300 + 100 + "px",
    height: Math.random() * 300 + 100 + "px",
    left: Math.random() * 100 + "%",
    top: Math.random() * 100 + "%",
  };
}

export default App;
